// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"520":"974f389d63a5a9c5","526":"db16225ca1e61ef3"}[chunkId] + ".js";
};